import { createProductDetail } from '@dh-io-emh/commerce-api/src/mappers/ocb/product.mapper';
import { ProductDetail } from '@dh-io-emh/commerce-api/src/models/product';
import { AppConfig } from '@dh-io-emh/config-types';
import { createHttpService } from '../../utils/http.util';
import { SMSPointOfService } from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';
import { parseSearchProductsRequest } from './product.api.helper';
import { ProductApi, ProductSearchRequestParams, ProductSearchResponse, Vendor } from './product.api.types';
import { getTranslationFallback, getTranslationUnitFallback } from '../../utils/translation.utils';
import { getEngineDescription } from '../../utils/engine-description.util';
import { ExtendedSMSProduct } from '@dh-io-emh/commerce-api/src/models/shared/ocb';

export const createProductApiBff = ({ config }: { config: AppConfig }): Partial<ProductApi> => {
  const { lang, siteId } = config;

  const httpPDP = createHttpService({
    url: config.pdp.bffService.apiUrl.replace('{{siteId}}', siteId),
    params: { lang },
  });
  const httpSRP = createHttpService({
    url: config.srp.bffService.apiUrl.replace('{{siteId}}', siteId),
    params: { lang },
  });

  return {
    ...(config.srp.bffService.enabled && {
      /**
       * Returns a list of products and additional data such as: available filters,
       * available sorting and pagination options.
       *
       * @returns {Promise}
       */
      async searchProducts(searchProductsParams: ProductSearchRequestParams): Promise<ProductSearchResponse> {
        return await parseSearchProductsRequest(searchProductsParams, config, {
          httpService: httpSRP,
          requestUrl: '',
        });
      },
    }),

    ...(config.pdp.bffService.enabled && {
      /**
       * Returns list of products regarding to received array of product codes.
       *
       * @param {string} productCode
       * @returns {Promise}
       */
      getProduct: async (productCode: string): Promise<{ product: ProductDetail; vendor: Vendor }> => {
        const product = await httpPDP
          .get<ExtendedSMSProduct>(`${productCode}`, {
            params: {
              fields: 'FULL',
            },
          })
          .then((res) =>
            createProductDetail(res.data, {
              i18n: {
                lang,
                getEngineDescription,
                getTranslationFallback,
                getTranslationUnitFallback,
              },
            }),
          );

        return { product, vendor: { pointOfServices: product.pointOfServices as Required<SMSPointOfService>[] } };
      },
    }),
  };
};
